import React, { Component } from 'react';
import {SearchErr} from '../../components/errorpage';
import ListContainer from './ListContainer';
import ListHeader from './ListHeader';

import {Api} from '../../util';


const headerData = [
    {
      id: 'NUM',
      title: '순번'
    },
    {
      id: 'ODT',
      title: '다운로드 일시'
    },
    // {
    //   id: 'SCHID',
    //   title: '채널명'
    // },
    {
      id: 'EPGID',
      title: '채널명'
    },
    {
      id: 'DOWNNAME',
      title: '파일명'
    },
    {
      id: 'MEMO',
      title: '설명'
    },
    // {
    //   id: 'STATE',
    //   title: '상태'      
    // }
];

class OrdLogContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      pathList: [],
      fmtList: []
    }
  }
    async componentDidMount(){
      // await Promise.all([
      //     this.SearchFmt(),
      //     this.SearchPath()
      // ]);
    }

    async SearchPath(){
      let pathList = [];
      try{
          this.setState({loadingFlag: true});
          const resPath = await Api.SearchPath();
          pathList = resPath.files.path;
          this.setState({
              pathList
          })
      } catch(e) {
          console.log(e, "SearchPath");
      } finally {
          this.setState({
              loadingFlag: false
          });
      }
    }

    // 포맷 검색
    async SearchFmt(){
      let fmtList = [];
      try{
          this.setState({loadingFlag: true});
          const resFmt = await Api.SearchFmt();
          fmtList = resFmt.files.fmt;
          this.setState({
              fmtList
          })
      } catch(e) {
          console.log(e, "SearchFmt");
      } finally {
          this.setState({
              loadingFlag: false
          });
      }
  }

    render() {
        const {pathList, fmtList} = this.state;
        const {list} = this.props;
        return (
            <div className='list-container'>
                {list.length > 0 ? 
                <div className="list-wrap">
                    <table className="list">
                      <thead>
                        <ListHeader headerData={headerData} />
                      </thead>
                      <tbody>
                        {list.map(item => 
                            <ListContainer item={item} 
                              pathList={pathList}
                              fmtList={fmtList}
                              key={`item_${item.NUM}`} 
                              headerData={headerData}
                            />
                        )}
                      </tbody>
                    </table>
                </div>
                : <SearchErr />
                }
            </div>
        );
    }
}

export default OrdLogContainer;


// WEBPACK FOOTER //
// ./src/containers/downloadlog/OrdLogContainer.js